module.exports = __webpack_public_path__ + "static/img/cha-lr-5.334815a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cha/cha-lr-5.png
// module id = oLjS
// module chunks = 1